/**
 * Route definitions. Entry point to all routes.
 */

import React from 'react';
import { Route } from 'react-router';

import Container from './container';
import dataDependencies from './data-dependencies';

const routes = (
  <Route
    dataDependencies={dataDependencies}
    render={({ match, location, history }) => (
      <Container match={match} history={history} location={location} />
    )}
  />
);

export default routes;
